module.exports = '<svg width="34" height="32" viewBox="0 0 34 32"><path d="M21.333 17.067a4.267 4.267 0 1 1-8.534 0 4.267 4.267 0 0 1 8.534 0zM32 4.267h-6.4V2.134c0-1.18-.954-2.133-2.133-2.133h-12.8c-1.18 0-2.133.954-2.133 2.133v2.133h-6.4C.954 4.267.001 5.221.001 6.4v23.467C.001 31.047.955 32 2.134 32h29.867c1.18 0 2.133-.954 2.133-2.133V6.4c0-1.18-.954-2.133-2.133-2.133zM17.067 25.6a8.533 8.533 0 1 1 0-17.066 8.533 8.533 0 0 1 0 17.066z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/camera-1.js
// module id = 1043
// module chunks = 14